import React from "react";
import "../FooterSite.css";
import { useNavigate, NavLink, Navigate, useLocation } from "react-router-dom";
import Botonera from "./Botonera";
const BotoneraWithFooter = () => {
    const navigate = useNavigate();
    return (
        
        <footer  class = "botoneraFooterSite" align="center">
        <Botonera/>
        
   </footer>

    );
}

export default BotoneraWithFooter;